import {
  Box,
  Button,
  Divider,
  Menu,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { type MouseEvent, useState } from "react";
import { UserAvatar } from "../UserAvatar";
import { LogoutButton } from "./LogoutButton";

type UserLogoutDropdownMenuProps = {
  picture?: string | null;
  firstName?: string;
  lastName?: string;
  name: string;
  email: string;
};

export const UserLogoutDropdownMenu = ({
  picture,
  firstName,
  lastName,
  name,
  email,
}: UserLogoutDropdownMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const {
    colors,
    customFontWeight,
    customShadows,
    customSpacing,
    radius,
    width,
  } = useTheme();
  const isOpen = !!anchorEl;

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Button
        onClick={handleClick}
        sx={{
          width: 40,
          height: 40,
          minWidth: 0,
          padding: 0,
          borderRadius: radius.full,
          backgroundColor: "transparent",
          border: `2px solid ${colors.border.primary}`,
          "&:hover": {
            backgroundColor: colors.background.hover,
          },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box sx={{ width: 36, height: 36 }}>
          <UserAvatar
            picture={picture}
            firstName={firstName}
            lastName={lastName}
            size="sm"
            showBorder={false}
          />
        </Box>
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            width: width.xs,
            my: customSpacing.md,
            borderRadius: radius.lg,
            boxShadow: customShadows.md,
          },
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          sx={{
            px: customSpacing.md,
            gap: customSpacing.md,
          }}
        >
          <UserAvatar
            picture={picture}
            firstName={firstName}
            lastName={lastName}
            size="md"
          />
          <Stack justifyContent="center">
            <Typography variant="body2" fontWeight={customFontWeight.bold}>
              {name}
            </Typography>
            <Typography variant="body2" color={colors.text.secondary}>
              {email}
            </Typography>
          </Stack>
        </Stack>

        <Divider
          sx={{
            py: customSpacing.md,
            color: colors.border.primary,
          }}
        />

        <LogoutButton />
      </Menu>
    </Box>
  );
};
